// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  position: relative;
  display: flex;
  align-items: flex-start;
}
.wrapper .map_section {
  width: 75%;
  height: 100%;
  transition: ease-in-out 1s;
}
.wrapper .map_section.full-width {
  width: 100%;
}
@media (max-width: 992px) {
  .wrapper .map_section {
    width: 100%;
  }
}
.wrapper .map_section.hide_section {
  width: 0%;
}
.wrapper .sidebar_section {
  padding-top: 11vw;
  width: 25%;
  box-shadow: -4.141304493px 0px 56.9429397583px 0px rgba(0, 0, 0, 0.1019607843);
  background: url('background.png') no-repeat center center/120% 120%;
  background-size: cover;
  transition: width 1.5s flex-direction 2s;
  overflow: auto;
  display: flex;
  flex-direction: column;
  transition: ease-in-out 1s;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
}
@media (max-width: 992px) {
  .wrapper .sidebar_section {
    width: 0;
  }
  .wrapper .sidebar_section app-venue-suggestion {
    visibility: none;
    opacity: 0;
    transition: opacity 1s ease-in-out;
  }
}
.wrapper .sidebar_section.full-width {
  padding: 100px 50px;
  transition: all 1s;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  flex-direction: row;
}
.wrapper .sidebar_section.full-width .title {
  display: none;
  visibility: none;
  opacity: 0;
  transition: visibility 2s;
}
@media (max-width: 992px) {
  .wrapper .sidebar_section.full-width {
    flex-direction: column !important;
    width: 100% !important;
    padding: 100px 20px;
    flex-wrap: nowrap;
  }
}
.wrapper .sidebar_section.full-width app-venue-suggestion {
  width: 24%;
}
@media (max-width: 992px) {
  .wrapper .sidebar_section.full-width app-venue-suggestion {
    width: 100%;
    opacity: 1;
  }
}

#map {
  width: 100%;
  height: 100%;
  z-index: 0;
}
#map img {
  max-height: none !important;
  max-width: none !important;
}

.search-bar {
  border-radius: 4px;
  line-height: 1.6;
  width: 100%;
}

.search-bar > div {
  height: 100%;
  display: flex;
  flex-direction: row;
  place-items: center;
}

.title {
  font-family: AppFontBold, sans-serif;
  font-size: 14px;
  text-transform: uppercase;
  margin-left: 15px;
  margin-top: 15px;
}

#search-container {
  top: 0px;
  left: 0px;
  right: 0px;
  position: absolute;
  padding: 0px;
  background: white;
}
#search-container app-venue-suggestion {
  width: 100%;
}

.search-container-input {
  top: 30px;
  left: 0px;
  right: 0px;
  position: absolute;
  padding: 0px;
  background: white;
}

.slides-container {
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
}

.swiper-slide {
  align-self: flex-end;
}

app-venue-suggestion {
  width: 100%;
}
@media (max-width: 992px) {
  app-venue-suggestion {
    width: 90%;
  }
}

.map-toggle {
  display: flex;
  justify-content: space-between !important;
  align-items: center;
  padding: 5px;
}

.map-toggle-container {
  height: 48px;
}

.mode-icon {
  padding: 10px;
  height: 25px;
  width: 25px;
}

.mode-icon {
  fill: #808080;
  transition: 0.3s linear;
}

.mode-icon.selected {
  background: var(--ion-color-primary);
  fill: #f8f8f8;
  transition: 0.3s linear;
}

.full-height {
  height: 100%;
}

.sidebar {
  overflow: auto;
  height: 100%;
}
.sidebar app-venue-suggestion {
  margin: 5px auto;
}
.sidebar .title {
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}

.loading-container {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 10;
  background: black;
  opacity: 0.5;
}
.loading-container ion-spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 70px;
  height: 70px;
  color: white;
}
@media (min-width: 991px) {
  .loading-container ion-spinner {
    width: 80px;
    height: 80px;
  }
}

.hint {
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 14px;
  background: white;
}
.hint p {
  font-size: 12px;
  color: black;
  margin: 0;
  padding: 0 8px;
}
.hint span {
  font-size: 14px;
}
.hint ion-icon {
  height: 44px;
  width: 44px;
  place-self: center;
}

.center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.block-venues {
  background: #f8f8f8;
}

.full-height {
  height: 100%;
}

#show_toggler, #search-container-input {
  position: absolute;
  top: 11vw !important;
  left: 40%;
  border: 1px solid var(--ion-color-primary);
  transform: translateX(-50%);
  width: 60vw;
  display: flex;
  height: 90px;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0px 0px 50px 0px rgba(0, 0, 0, 0.1019607843);
  background: white;
  padding: 10px;
  transition: top 1s;
  z-index: 10;
}
#show_toggler.full-width, #search-container-input.full-width {
  left: 50%;
}
@media (max-width: 992px) {
  #show_toggler, #search-container-input {
    width: 350px;
    height: 55px;
    left: 50%;
  }
}
#show_toggler h3, #search-container-input h3 {
  font-family: AppFontBold, sans-serif;
  font-size: 20px;
}
#show_toggler.move_up, #search-container-input.move_up {
  top: 10px;
}

swiper-slide {
  display: flex;
  justify-content: center;
  margin-top: auto;
}

app-map-search-venue {
  width: 100%;
}

#show_toggler h3 {
  text-transform: uppercase;
  font-size: 16px;
}

.scroll-block {
  max-height: calc(100vh - 95px);
  --background: transparent;
  background: transparent;
  --padding-start: 20px;
  --padding-end: 20px;
}

.search-restaurant {
  width: 100%;
  margin-left: 10px;
  color: var(--ion-color-primary);
}
.search-restaurant ion-input {
  font-family: AppFontBold, sans-serif;
  font-size: 24px;
  color: #808080;
}
@media (max-width: 992px) {
  .search-restaurant ion-input {
    font-size: 16px;
  }
}

.seach-icon-large {
  zoom: 1.4;
}

.mode-icon {
  cursor: pointer;
}

.slide-item {
  position: relative;
  padding: 0px 15px 0px;
}
.slide-item .back_icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 5px;
  color: var(--ion-color-primary);
  fill: var(--ion-color-primary);
  width: 30px;
  height: 50px;
}
.slide-item .forward_icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 5px;
  color: var(--ion-color-primary);
  fill: var(--ion-color-primary);
  width: 30px;
  height: 50px;
}`, "",{"version":3,"sources":["webpack://./src/maps/components/map-venue/map-venue.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;AADF;AAEE;EACE,UAAA;EAIA,YAAA;EACA,0BAAA;AAHJ;AADI;EACE,WAAA;AAGN;ACLE;EDDA;IAQI,WAAA;EAEJ;AACF;AADI;EACE,SAAA;AAGN;AAAE;EASE,iBAAA;EACA,UAAA;EACA,8EAAA;EACA,mEAAA;EACA,sBAAA;EACA,wCAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EAEA,0BAAA;EACA,2BAAA;EACA,mBAAA;EACA,YAAA;AAPJ;AC5BE;EDaA;IAEI,QAAA;EAiBJ;EAhBI;IACE,gBAAA;IACA,UAAA;IACA,kCAAA;EAkBN;AACF;AADI;EAQE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;AAJN;AATM;EACE,aAAA;EACA,gBAAA;EACA,UAAA;EACA,yBAAA;AAWR;ACtDE;EDqCE;IAiBI,iCAAA;IACA,sBAAA;IACA,mBAAA;IACA,iBAAA;EAIN;AACF;AAFM;EACE,UAAA;AAIR;ACjEE;ED4DI;IAGI,WAAA;IAEA,UAAA;EAKR;AACF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,UAAA;AAFF;AAIE;EACE,2BAAA;EACA,0BAAA;AAFJ;;AAOA;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;AAJF;;AAOA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AAJF;;AAMA;EACE,oCAAA;EACA,eAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;AAHF;;AAKA;EACE,QAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AAFF;AAIE;EACE,WAAA;AAFJ;;AAKA;EACE,SAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AAFF;;AAIA;EACE,kBAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;AADF;;AAIA;EACE,oBAAA;AADF;;AAIA;EACE,WAAA;AADF;AC1IE;ED0IF;IAGI,UAAA;EACF;AACF;;AACA;EACE,aAAA;EACA,yCAAA;EACA,mBAAA;EACA,YAAA;AAEF;;AAAA;EACE,YAAA;AAGF;;AAEA;EACE,aAAA;EACA,YAAA;EACA,WAAA;AACF;;AAEA;EAEE,aAAA;EACA,uBAAA;AAAF;;AAGA;EACE,oCAAA;EACA,aAAA;EACA,uBAAA;AAAF;;AAGA;EACE,YAAA;AAAF;;AAGA;EAKE,cAAA;EACA,YAAA;AAJF;AADE;EACE,gBAAA;AAGJ;AAGE;EACE,UAAA;EACA,iBAAA;EACA,kBAAA;AADJ;;AAIA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;AADF;AAEE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAAJ;ACtNE;ED+MA;IASI,WAAA;IACA,YAAA;EAEJ;AACF;;AAEA;EACE,wCAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;AACF;AACE;EACE,eAAA;EACA,YAAA;EACA,SAAA;EACA,cAAA;AACJ;AAEE;EACE,eAAA;AAAJ;AAGE;EACE,YAAA;EACA,WAAA;EACA,kBAAA;AADJ;;AAKA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAIA;EACE,YAAA;AADF;;AAGA;EACE,kBAAA;EACA,oBAAA;EAEA,SAAA;EAIA,0CAAA;EACA,2BAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,8BAAA;EACA,wDAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;AAJF;AAVE;EACE,SAAA;AAYJ;AC9QE;ED4PF;IAqBI,YAAA;IACA,YAAA;IACA,SAAA;EACF;AACF;AACE;EACE,oCAAA;EACA,eAAA;AACJ;AACE;EACE,SAAA;AACJ;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;AACF;;AACA;EACE,WAAA;AAEF;;AACE;EACE,yBAAA;EACA,eAAA;AAEJ;;AACA;EACE,8BAAA;EACA,yBAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;AAEF;;AAGA;EACE,WAAA;EACA,iBAAA;EAUA,+BAAA;AATF;AAAE;EACE,oCAAA;EACA,eAAA;EACA,cAAA;AAEJ;AC9TE;EDyTA;IAKI,eAAA;EAIJ;AACF;;AACA;EACE,SAAA;AAEF;;AAAA;EACE,eAAA;AAGF;;AADA;EACE,kBAAA;EACA,qBAAA;AAIF;AAHE;EACE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,SAAA;EACA,+BAAA;EACA,8BAAA;EACA,WAAA;EACA,YAAA;AAKJ;AAHE;EACE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,+BAAA;EACA,8BAAA;EACA,WAAA;EACA,YAAA;AAKJ","sourcesContent":["@import \"../../../theme/mixins\";\n\n.wrapper {\n  position: relative;\n  display: flex;\n  align-items: flex-start;\n  .map_section {\n    width: 75%;\n    &.full-width {\n      width: 100%;\n    }\n    height: 100%;\n    transition: ease-in-out 1s;\n    @include mobile {\n      width: 100%;\n    }\n    &.hide_section {\n      width: 0%;\n    }\n  }\n  .sidebar_section {\n    @include mobile {\n      width: 0;\n      app-venue-suggestion {\n        visibility: none;\n        opacity: 0;\n        transition:  opacity 1s ease-in-out;\n      }\n    }\n    padding-top: 11vw;\n    width: 25%;\n    box-shadow: -4.1413044929504395px 0px 56.94293975830078px 0px #0000001A;\n    background: url('../../../assets/background/background.png') no-repeat center center / 120% 120%;\n    background-size: cover;;\n    transition: width 1.5s flex-direction 2s;\n    overflow: auto;\n    display: flex;\n    flex-direction: column;\n\n    transition: ease-in-out 1s;\n    justify-content: flex-start;\n    align-items: center;\n    height: 100%;\n\n    &.full-width {\n    \n      .title {\n        display: none;\n        visibility: none;\n        opacity: 0;\n        transition: visibility 2s;\n      }\n      padding: 100px 50px;\n      transition: all 1s;\n      width: 100%;\n      display: flex;\n      justify-content: space-between;\n      align-items: flex-start;\n      flex-wrap: wrap;\n      flex-direction: row;\n      @include mobile {\n        flex-direction: column !important;\n        width: 100% !important;\n        padding: 100px 20px;\n        flex-wrap: nowrap;\n\n      }\n      app-venue-suggestion {\n        width: 24%;\n        @include mobile {\n          width: 100%;\n\n          opacity: 1;\n\n        }\n      }\n    }\n  }\n}\n\n\n\n\n#map {\n  width: 100%;\n  height: 100%;\n  z-index: 0;\n\n  img {\n    max-height: none !important;\n    max-width: none !important;\n  }\n}\n\n\n.search-bar {\n  border-radius: 4px;\n  line-height: 1.6;\n  width: 100%;\n}\n\n.search-bar > div {\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  place-items: center;\n}\n.title {\n  font-family: AppFontBold, sans-serif;\n  font-size: 14px;\n  text-transform: uppercase;\n  margin-left: 15px;\n  margin-top: 15px;\n}\n#search-container {\n  top: 0px;\n  left: 0px;\n  right: 0px;\n  position: absolute;\n  padding: 0px;\n  background: white;\n\n  app-venue-suggestion {\n    width: 100%;\n  }\n}\n.search-container-input {\n  top: 30px;\n  left: 0px;\n  right: 0px;\n  position: absolute;\n  padding: 0px;\n  background: white;\n}\n.slides-container {\n  position: absolute;\n  bottom: 20px;\n  left: 0;\n  right: 0;\n}\n\n.swiper-slide {\n  align-self: flex-end;\n}\n\napp-venue-suggestion {\n  width: 100%;\n  @include mobile {\n    width: 90%;\n  }\n}\n.map-toggle {\n  display: flex;\n  justify-content: space-between !important;\n  align-items: center;\n  padding: 5px;\n}\n.map-toggle-container {\n  height: 48px;\n\n\n}\n\n.mode-icon {\n  padding: 10px;\n  height: 25px;\n  width: 25px;\n}\n\n.mode-icon {\n\n  fill:#808080;\n  transition: 0.3s linear;\n}\n\n.mode-icon.selected {\n  background: var(--ion-color-primary);\n  fill: #f8f8f8;\n  transition: 0.3s linear;\n}\n\n.full-height {\n  height: 100%;\n}\n\n.sidebar {\n  app-venue-suggestion {\n    margin: 5px auto;\n  }\n\n  overflow: auto;\n  height: 100%;\n\n  .title {\n    width: 90%;\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n.loading-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  z-index: 10;\n  background: black;\n  opacity: 0.5;\n  ion-spinner {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 70px;\n    height: 70px;\n    color: white;\n    @include desktop {\n      width: 80px;\n      height: 80px;\n    }\n  }\n}\n\n.hint {\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);\n  border-radius: 4px;\n  padding: 14px;\n  background: white;\n\n  p {\n    font-size: 12px;\n    color: black;\n    margin: 0;\n    padding: 0 8px;\n  }\n\n  span {\n    font-size: 14px;\n  }\n\n  ion-icon {\n    height: 44px;\n    width: 44px;\n    place-self: center;\n  }\n}\n\n.center {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.block-venues {\n  background: #f8f8f8;\n}\n.full-height {\n  height: 100%;\n}\n#show_toggler , #search-container-input {\n  position: absolute;\n  top: 11vw!important;\n\n  left: 40%;\n  &.full-width {\n    left: 50%;\n  }\n  border: 1px solid var(--ion-color-primary);\n  transform: translateX(-50%);\n  width: 60vw;\n  display: flex;\n  height: 90px;\n  align-items: center;\n  justify-content: space-between;\n  box-shadow: 0px 0px 50px 0px #0000001A;\n  background: white;\n  padding: 10px;\n  transition: top 1s;\n  z-index: 10;\n  @include mobile {\n    width: 350px;\n    height: 55px;\n    left: 50%;\n  }\n \n  h3 {\n    font-family: AppFontBold, sans-serif;\n    font-size: 20px;\n  }\n  &.move_up {\n    top: 10px;\n  }\n}\nswiper-slide {\n  display: flex;\n  justify-content: center;\n  margin-top: auto;\n}\napp-map-search-venue {\n  width: 100%;\n}\n#show_toggler {\n  h3 {\n    text-transform: uppercase;\n    font-size: 16px;\n  }\n}\n.scroll-block {\n  max-height: calc(100vh - 95px);\n  --background: transparent;\n  background: transparent;\n  --padding-start: 20px;\n  --padding-end: 20px;\n  // app-venue-suggestion {\n  //   width: 100% !important;\n  // }\n}\n.search-restaurant {\n  width: 100%;\n  margin-left: 10px;\n  ion-input {\n    font-family: AppFontBold, sans-serif;\n    font-size: 24px;\n    color: #808080;\n     @include mobile {\n      font-size: 16px;\n     }\n  }\n\n  color: var(--ion-color-primary)\n}\n.seach-icon-large {\n  zoom: 1.4;\n}\n.mode-icon {\n  cursor: pointer;\n}\n.slide-item {\n  position: relative;\n  padding: 0px 15px 0px;\n  .back_icon {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    left: 5px;\n    color: var(--ion-color-primary);;\n    fill: var(--ion-color-primary);\n    width: 30px;\n    height: 50px;\n  }\n  .forward_icon {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    right: 5px;\n    color: var(--ion-color-primary);;\n    fill: var(--ion-color-primary);\n    width: 30px;\n    height: 50px;\n\n  }\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
